@if (isLoggingOutToApp) {
<div class="logout-transition" role="status" aria-live="polite">
  <div class="logout-transition-content">
    <span class="logout-transition-logo" aria-hidden="true">
      <img src="assets/logo-login.svg" alt="" />
    </span>
    <h1>Signed out</h1>
    <p>Returning to your service</p>
    <span class="logout-transition-progress" aria-hidden="true"></span>
  </div>
</div>
} @else if (isLoadingSplash) {
<app-splash-screen></app-splash-screen>
} @else {
<div class="login-wrapper">
  <div style="display: flex; align-items: center; justify-content: center">
    <div class="logo-container">
      <img src="assets/logo-login.svg" alt="" height="120px" width="120px" />
    </div>
  </div>
  <span class="login-title">Satsang login</span>

  @switch (state.view) {
  @case ('contact') {
  <app-contact-step
    [form]="loginForm"
    [selectedCountry]="selectedCountry"
    [countryList]="countryList"
    [isLoading]="isLoading"
    [errorText]="state.contactError"
    [buttonDisabled]="isButtonDisabled().isDisabled"
    (submitted)="onSubmit()"
    (countrySelected)="onSelectCountry($event)" />
  }
  @case ('password') {
  <app-password-step
    [form]="loginForm"
    [isLoading]="isLoading"
    [errorText]="state.passwordError"
    [isPasswordVisible]="isPasswordVisible"
    [canResetPassword]="selectedCountry.value === 'NEPAL'"
    (submitted)="verifyPassword()"
    (visibilityToggled)="togglePassword()"
    (forgotPasswordRequested)="requestForgotPasswordOtp()"
    (backed)="goBack()" />
  }
  @case ('forgotPassword') {
  <app-forgot-password-step
    [form]="forgotPasswordForm"
    [contact]="loginForm.get('contact')?.value || ''"
    [isLoading]="isLoading"
    [errorText]="forgotPasswordError"
    (submitted)="updateForgotPassword()"
    (resent)="requestForgotPasswordOtp()"
    (backed)="backFromForgotPassword()" />
  }
  @case ('otp') {
  <app-otp-step
    [otp]="state.otp"
    [otpError]="state.otpError"
    [otpSentTo]="state.otpSentTo"
    [countdown]="state.countdown"
    [isLoading]="isLoading"
    (otpChange)="onOtpChange($event)"
    (verified)="verifyOtp()"
    (resent)="resendOtp()"
    (backed)="goBack()" />
  }
  @case ('recovery') {
  <app-recovery-setup
    [form]="recoveryForm"
    [recovery]="recovery"
    [steps]="recoverySteps"
    [isLoading]="isLoading"
    [isPasswordVisible]="isPasswordVisible"
    (stepSelected)="goToRecoveryStep($event)"
    (skipped)="skipRecoveryStep()"
    (finished)="finishRecoverySetup()"
    (passwordSet)="setRecoveryPassword()"
    (otpSent)="sendRecoveryOtp()"
    (otpVerified)="verifyRecoveryOtp()"
    (otpCancelled)="cancelRecoveryOtp()" />
  }
  @case ('restore') {
  <app-restore-account
    [restore]="restore"
    (restored)="restoreAccount()"
    (accountSwitched)="useAnotherAccount()" />
  }
  @default {
  <app-trusted-device
    [trusted]="trusted"
    [showTrustButton]="selectedCountry.value !== 'NEPAL'"
    (trustRequested)="trustThisDevice()"
    (untrustedRequested)="continueUntrusted()"
    (deviceSelected)="selectDeviceToRemove($event)"
    (removalConfirmed)="confirmDeviceRemovalAndTrust()"
    (selectionCancelled)="cancelDeviceSelection()"
    (codeVerified)="verifyTrustCode()"
    (codeResent)="resendTrustCode()"
    (codeCancelled)="cancelTrustCode()" />
  }
  }

  <div class="contact-footer">
    <div class="contact-heading">
      <span class="contact-line"></span>
      <span class="contact-title">Facing an issue? Contact us</span>
      <span class="contact-line"></span>
    </div>
    <div class="contact-groups">
      @for (group of contactGroups; track group.label) {
      <div class="contact-group">
        <span class="contact-label">{{ group.label }}</span>
        <div class="contact-chips">
          @for (item of group.items; track item.value) {
          <button
            type="button"
            class="contact-chip"
            [class.copied]="copiedContact === item.value"
            title="Click to copy"
            [attr.aria-label]="'Copy ' + item.value"
            (click)="copyContact(item.value)">
            @if (copiedContact === item.value) {
            <span class="copied-pill">Copied</span>
            }
            <span class="chip-text">{{ item.value }}</span>
          </button>
          }
        </div>
      </div>
      }
    </div>

    @if (contactGroups.length && contactGroups[0].items.length) {
    <div class="contact-preview">
      @if (contactGroups[0].label.toLowerCase() !== 'contact us') {
      <span>{{ contactGroups[0].label }}:</span>
      }
      <span>{{ contactGroups[0].items[0].value }}</span>
    </div>
    }
    <button type="button" class="contact-more" (click)="openContactSheet()" aria-haspopup="dialog">
      <span aria-hidden="true">⌃</span>
      Tap for more contact info
    </button>
    <span class="sr-only" role="status" aria-live="polite">{{
      copiedContact ? 'Copied ' + copiedContact : ''
    }}</span>
  </div>

  <dialog #contactDialog class="contact-sheet" aria-labelledby="contact-sheet-title"
    (click)="onContactSheetClick($event)">
    <div class="contact-sheet-content">
      <span class="contact-sheet-handle" aria-hidden="true"></span>
      <div class="contact-sheet-header">
        <span aria-hidden="true"></span>
        <h2 id="contact-sheet-title">Contact us</h2>
        <button type="button" class="contact-sheet-done" (click)="closeContactSheet()">Done</button>
      </div>
      @for (group of contactGroups; track group.label) {
      <section class="contact-sheet-group" [attr.aria-label]="group.label">
        <h3>{{ group.label.toLowerCase().startsWith('for ') ? group.label.slice(4) : group.label }}</h3>
        <div class="contact-sheet-card">
          @for (item of group.items; track item.value) {
          <button type="button" class="contact-sheet-row"
            [attr.aria-label]="'Copy ' + item.value" (click)="copyContact(item.value)">
            @if (item.kind === 'phone') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M22 16.9v3a2 2 0 0 1-2.2 2A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7l.4 2.8a2 2 0 0 1-.6 1.7L7 10a16 16 0 0 0 7 7l1.8-1.9a2 2 0 0 1 1.7-.6l2.8.4a2 2 0 0 1 1.7 2z" />
            </svg>
            } @else {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="m22 7-10 7L2 7" />
            </svg>
            }
            <span class="contact-sheet-value">{{ item.value }}</span>
            <span class="contact-sheet-action" aria-hidden="true">
              {{ copiedContact === item.value ? 'Copied' : 'Copy' }}
            </span>
          </button>
          }
        </div>
      </section>
      }
    </div>
  </dialog>
</div>
}
